import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";


export const getDriverList = createAsyncThunk(`driver/getDriverList`, async () => {
    try {
        const response = await api.driver.getDriverList();
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
});

export const getDriver = createAsyncThunk(
    `driver/getDriver`,
    async (id: number) => {
        try {
          const response = await api.driver.getDriver(id);
          return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
)

export const createDriver = createAsyncThunk(`driver/createDriver`,
async(data:any) => {
    try {
        const response = await api.driver.createDriver(data);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
})
